import { ReactElement } from 'react';
import { Typography } from '@mui/material';

export const PageTitle = ({ children }: { children: ReactElement | string }) => {
  return (
    <Typography
      sx={{
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '28px',
        font: 'Noto Sans',
        margin: '0',
      }}
    >
      {children}
    </Typography>
  );
};
